'use strict';

const inStore = require('./pages/product/inStore');
const ajax = require('./modules/ajax');
const scrollHelper = require('./modules/helpers/scroll');
const ritualsFormHelper = require('./rituals-form-helper');
const damHelper = require('./dam/dam-helper');

const isPG = $('.js-pdp-main').hasClass('giftset-pdp-main-container');
const pgCustomizeEvents = {
    onSubmit: $.Event('pgCustomize.onSubmit')
};

function initEvents(){
    // Instore availability flyout
    inStoreFlyoutEvents();

    // close flyouts when clicking the modal overlay or the flyout close button
    $(document).on('click touchstart', '.js-modal-overlay, .js-close-flyout, .js-side--close', function(){
        closeFlyouts();
    });

    $('.js-close-flyout').on('keyup', function(e){
        if (e.which == 13) {
           // on enter close the flyout
           closeFlyouts();
         }
    });

    $(document).on('keyup', function(e) {
        if (e.which == 27 && (
            flyout.def.$minicartFlyout.hasClass('open') ||
            flyout.def.$inStoreAvailabilityEl.hasClass('open') ||
            flyout.def.$inStoreAvailabilityHor.hasClass('open') ||
            flyout.def.$flyoutGeneralEl.hasClass('open'))) {
            // on escape close the flyout
            closeFlyouts();
       }
   });

    //if flyouts are closed, disable tabbing through them
    if (!flyout.def.$minicartFlyout.hasClass('open')) {
        flyout.def.$minicartFlyout.find('a, button, .js-miniflyout-skip-to-content').attr('tabindex', '-1');
    }

    if (!flyout.def.$inStoreAvailabilityEl.hasClass('open')) {
        flyout.def.$inStoreAvailabilityEl.find('.js-close-flyout, input, a, button, .js-check-instore-availabilty-wrapper, .js-flyout-skip-to-content').attr('tabindex', '-1');
    }

    if (!flyout.def.$inStoreAvailabilityHor.hasClass('open')) {
        flyout.def.$inStoreAvailabilityHor.find('.js-close-flyout, input, a, button, .js-check-instore-availabilty-hor-wrapper, .js-flyout-skip-to-content').attr('tabindex', '-1');
    }

    if (!flyout.def.$flyoutGeneralEl.hasClass('open')) {
        flyout.def.$flyoutGeneralEl.find('.js-close-flyout, input, button, a, .js-genericflyout-skip-to-content').attr('tabindex', '-1');
    }

    //if mobile confirmation popup is closed, disable tabbing through it
    if (!$('.js-cart-confirm-mobile').hasClass('open')) {
        $('.js-cart-confirmation-wrapper').attr('tabindex', '-1');
    }

    if (isPG) {
        $('.js-mobile-cart-confirmation-link').on('click', function() {
            $(document).trigger(pgCustomizeEvents.onSubmit);
        });
    }
}

/**
 * @function
 * @description inits events for the instore availability flyout
 */
function inStoreFlyoutEvents(){
    // Show extra store info when user clicks arrow
    $('body').on('click', '.js-expand-row-btn', inStoreAccordions);

    $('body').on('keyup', '.js-expand-row-btn', function(e){
        if (e.which == 13) {
           // on enter open the accordion
           inStoreAccordions(e);
        }
    });

}

function inStoreAccordions(e) {
    const $this = $(e.target);
     // prevent bubbling (and collapsing the panel) when clicking in the "call store" button
     if ($this.hasClass('js-call-store-button')){
        return;
    }

    const extraInfoPanel = $this.closest('.js-list-row').find('.js-extra-info');
    extraInfoPanel.toggleClass('collapsed');
    $this.toggleClass('active');

    // get automatic height value of the panel
    const autoHeight = extraInfoPanel.css('height', 'auto').height();

    if (extraInfoPanel.hasClass('collapsed')){
        extraInfoPanel.stop().animate({height: 0}, 300);

        extraInfoPanel.parent().removeClass('active');
    } else {
        extraInfoPanel.height(0).stop().animate({height: autoHeight + 20}, 300); // + 20px to add margin to top
        extraInfoPanel.parent().addClass('active');
    }
}

/**
 * @function
 * @description Open Instore availability flyout
 */
function openInStoreAvailabilityFlyout(skipRefreshing){
    // When ROPO flyout opens refresh flyout, clean previous stores etc
    if (!skipRefreshing){
        inStore.refreshFlyout();
    }

    open({
        flyoutType: 'instoreavailability'
    });
}

/**
 * @function
 * @description Open Instore availability for HOR products flyout
 */
function openInStoreAvailabilityHORFlyout(){
    open({
        flyoutType: 'instoreavailability-hor'
    });
}

/**
 * @function
 * @description General open flyout function
 * @param {object} params
 * can be: instoreavailability, minicart ... TODO: add here more flyouts
 */
function open(params){
    if (params.flyoutType) {
        if (params.flyoutType === 'instoreavailability'){
            flyout.def.$inStoreAvailabilityEl.addClass('open');
            $('.js-flyout-skip-to-content').focus();

            //if ROPO is open, enable tabbing through it
            flyout.def.$inStoreAvailabilityEl.find('.js-close-flyout, input, a, button, .js-check-instore-availabilty-wrapper, .js-flyout-skip-to-content').attr('tabindex', '0');

            $(document).on('keydown', '.js-check-instore-availabilty-wrapper', function (e) {
                if (!$('.wrap-details').length) {
                    if (e.which == 9 && !e.shiftKey) {
                        e.preventDefault();
                        $('.js-instore-availability-flyout').find('.js-close-flyout').focus();
                    }
                }
            });

            $('.js-show-more-btn').on('keydown', function (e) {
                if (e.which == 9 && !e.shiftKey) {
                    e.preventDefault();
                    $('.js-instore-availability-flyout').find('.js-close-flyout').focus();
                } else if (e.which == 9 && e.shiftKey) {
                    e.preventDefault();
                    flyout.def.$inStoreAvailabilityEl.find('.wrap-details:last-child .list-row:last-child').focus();
                }
            });

            $('.js-close-flyout').on('keydown', function (e) {
                if (e.which == 9 && e.shiftKey) {
                    e.preventDefault();
                    if (!$('.wrap-details').length) {
                        $('.js-check-instore-availabilty-wrapper').focus();
                    } else if (!$('.js-show-more-btn').hasClass('js-hidden-show-more')) {
                        $('.js-show-more-btn').focus();
                    } else {
                        $('.wrap-details:last-child .js-list-row:last-child').focus();
                    }
                }
            });

            $('.js-close-flyout').on('keydown', function (e) {
                if (e.which == 9) {
                    if ($('.js-flyout-amsterdam').length) {
                        const $this = $(this);
                        e.preventDefault();
                        $this.focus();
                    }
                }
            });

        } else if (params.flyoutType === 'minicart') {
            flyout.def.$minicartFlyout.addClass('open');

            damHelper.updateImages($('.js-minicart-flyout'));

            //if minicart is open, enable tabbing through it
            flyout.def.$minicartFlyout.find('a, button, .js-miniflyout-skip-to-content').attr('tabindex', '0');

            $('.js-miniflyout-skip-to-content').focus();
            minicartHeights();
            let $lastButtonMinicart;

            //when a user finishes tabbing through the minicart, they will end up on the close icon
            if ($('.empty-minicart-bottom').length) {
                $lastButtonMinicart = flyout.def.$minicartFlyout.find('.empty-minicart-bottom').find('a.btn');
            } else {
                $lastButtonMinicart = flyout.def.$minicartFlyout.find('.js-minicart-flyout-checkout').find('button.btn');
            }

            $lastButtonMinicart.on('keydown', function (e) {
                if (e.which == 9 && !e.shiftKey) {
                    e.preventDefault();
                    flyout.def.$minicartFlyout.find('.js-close-flyout').focus();
                }
            });

            $('.js-close-flyout').on('keydown', function(e) {
                if (e.which == 9 && e.shiftKey) {
                    e.preventDefault();
                    $lastButtonMinicart.focus();
                }
            });

            if (isPG) {
                $('.js-minicart-flyout-checkout').find('button.btn').on('click', function() {
                    $(document).trigger(pgCustomizeEvents.onSubmit);
                });
            }

            $('.js-minicart-flyout-checkout').find('button[type="submit"]').on('click', function(){
                $(this).addClass('button-loading');
                $(this).find('.js-spinner-general').addClass('spinner-visible');
            });

            $('.js-minicart-flyout-spinner').find('button[type="submit"]').on('click', function(){
                $(this).addClass('hide');
                $('.js-spinner-general.spinner-custom-desktop').addClass('show');
            });
        } else if (params.flyoutType === 'instoreavailability-hor') {
            flyout.def.$inStoreAvailabilityHor.addClass('open');
            $('.js-flyout-skip-to-content').focus();

            //if flyout is open, enable tabbing through it
            flyout.def.$inStoreAvailabilityHor.find('.js-close-flyout, input, a, button, .js-check-instore-availabilty-hor-wrapper, .js-flyout-skip-to-content').attr('tabindex', '0');

            $(document).on('keydown', '.js-check-instore-availabilty-hor-wrapper', function (e) {
                if (!$('.wrap-details').length) {
                    if (e.which == 9 && !e.shiftKey) {
                        e.preventDefault();
                        $('.js-instore-availability-hor-flyout').find('.js-close-flyout').focus();
                    }
                }
            });

            $('.js-close-flyout').on('keydown', function (e) {
                if (e.which == 9) {
                    if ($('.js-flyout-hor').length) {
                        const $this = $(this);
                        e.preventDefault();
                        $this.focus();
                    }
                }
            });

        }
    } else {
        flyout.def.$genericFlyout.addClass('open');

        //if flyout is open, enable tabbing through it
        flyout.def.$flyoutGeneralEl.find('.js-close-flyout, input, button, a, .js-genericflyout-skip-to-content').attr('tabindex', '0');

        $('.js-genericflyout-skip-to-content').focus();

        //when a user finishes tabbing through the general flyout, they will end up on the close icon
        const $lastButtonFlyout = flyout.def.$genericFlyout.find('.js-password-reset-button');

        $lastButtonFlyout.on('keydown', function (e) {
            if (e.which == 9 && !e.shiftKey) {
                e.preventDefault();
                flyout.def.$genericFlyout.find('.js-close-flyout').focus();
            } else if (e.shiftKey && e.which == 9) {
                e.preventDefault();
                flyout.def.$genericFlyout.find('.input-row').find('input').focus();
            }
        });

        $(document).on('keydown', '.js-generic-flyout .js-close-flyout', function(e) {
            if (e.which == 13) {
                closeFlyouts();
                if ($('.js-password-reset-dialog').length) {
                    $('.js-password-reset-dialog').focus();
                }
            }
        });

        $(document).on('keydown', '.js-generic-flyout .js-close-flyout', function(e) {
            if (e.shiftKey && e.which == 9) {
                e.preventDefault();
                $lastButtonFlyout.focus();
            }
        });
    }

    // show modal overlay
    flyout.def.$modalOverlay.fadeIn();

    ritualsFormHelper.init();

    if ($('.js-personalised-promo-block-anchor').length) {
        $('html, body').stop().animate({
            scrollTop: $('.js-product-list-slider-block').offset().top
        }, 1600, 'easeOutQuart');

        setTimeout(() => {
            scrollHelper.disableScroll();
        }, 600);
        $('.js-product-list-slider-block').removeClass('js-personalised-promo-block-anchor');
    } else {
        // lock body scroll
        scrollHelper.disableScroll();
    }

    if (params.close) {
        flyout.def.$genericFlyout.off('closeFlyout');
        flyout.def.$genericFlyout.on('closeFlyout', function () {
            params.close();
        });
    }
}

/**
 * @function
 * @description Loads flyout content from the HTML that is already present on the page
 * @param {html} html content
 */
function loadFromHtml(html, options) {
    flyout.def.$flyoutContent.html(html);

    initEvents();

    const params = {};
    if (options.close){
        params.close = options.close;
    }

    open(params);

    if (options.open) {
        options.open();
    }
}

/**
 * @function
 * @description Loads flyout content through ajax and then opens and inits it
 * @param {object} params
 * can be: instoreavailability, minicart ... TODO: add here more flyouts
 */
function load(options){
    ajax.load({
        url: options.url,
        target: flyout.def.$flyoutContent,
        callback: function () {
            initEvents();
            const params = {};
            if (options.close){
                params.close = options.close;
            }
            open(params);
            if (options.open) {
                options.open();
            }
        }
    });
}

/**
 * @function
 * @description Close all flyouts and overlay
 */
function closeFlyouts(){
    // close all flyouts
    flyout.def.$flyoutGeneralEl.removeClass('open');

    $('.js-flyout-opened').focus();
    setTimeout(function() {
        $('.js-flyout-opened').removeClass('js-flyout-opened');
    },400);

    //if flyouts are closed, disable tabbing through them
    flyout.def.$minicartFlyout.find('a, button, .js-miniflyout-skip-to-content').attr('tabindex', '-1');
    flyout.def.$inStoreAvailabilityEl.find('.js-close-flyout, input, a, button, .js-check-instore-availabilty-wrapper, .js-flyout-skip-to-content').attr('tabindex', '-1');
    flyout.def.$inStoreAvailabilityHor.find('.js-close-flyout, input, a, button, .js-check-instore-availabilty-hor-wrapper, .js-flyout-skip-to-content').attr('tabindex', '-1');
    flyout.def.$flyoutGeneralEl.find('.js-close-flyout, input, button, a, .js-genericflyout-skip-to-content').attr('tabindex', '-1');

    // remove modal overlay
    flyout.def.$modalOverlay.fadeOut();

    // unlock body scroll
    scrollHelper.enableScroll();

    // Close possible mobile confirmation
    hideMobileConfirmation();

    flyout.def.$flyoutGeneralEl.trigger('closeFlyout');

    if ($('.js-generic-flyout').hasClass('address-flyout')) {
        setTimeout(function () {
            $('.js-generic-flyout').removeClass('address-flyout');
        }, 500);
    }
}

function isOpened() {
    return flyout.def.$genericFlyout.hasClass('open');
}

/**
 * @function
 * @description The hiding of the mobile confirmation
 */
function hideMobileConfirmation() {
    $('.js-cart-confirm-mobile').removeClass('open');
    $('.js-cart-confirmation-wrapper').attr('tabindex', '-1');
}

/**
 * @function
 * @description Check minicart contents height to show a shadow if content is scrollable
 */
function minicartHeights() {
    const $miniProducts = flyout.def.$minicartFlyout.find('.js-minicart-flyout-wrapper');
    const $miniTotals = flyout.def.$minicartFlyout.find('.js-minicart-flyout-checkout');

    if ($miniProducts.outerHeight() > flyout.def.$minicartFlyout.height() - $miniTotals.outerHeight()) {
        $miniTotals.addClass('has-shadow');
    } else {
        $miniTotals.removeClass('has-shadow');
    }
}

const flyout = {
    def: {
        $flyoutGeneralEl: $('.js-flyout-container'),
        $inStoreAvailabilityEl: $('.js-instore-availability-flyout'),
        $inStoreAvailabilityHor: $('.js-instore-availability-hor-flyout'),
        $minicartFlyout: $('.js-minicart-flyout'),
        $modalOverlay: $('.js-modal-overlay'),
        $genericFlyout: $('.js-generic-flyout'),
        $flyoutContent: $('.js-flyout-content')
    },
    init: function () {
        initEvents();
        inStore(); //Initialize inStore
    },
    open: open,
    load: load,
    loadFromHtml: loadFromHtml,
    isOpened: isOpened,
    openInStoreAvailabilityFlyout: openInStoreAvailabilityFlyout,
    openInStoreAvailabilityHORFlyout: openInStoreAvailabilityHORFlyout,
    closeFlyouts: closeFlyouts
};

module.exports = flyout;
